import { gql } from '@apollo/client'

export const GET_FAQS = gql`
  query GetFAQS($payload: FAQInput!) {
    frequently_asked_questions(payload: $payload) {
      id
      title
      body
      property_detail {
        id
        rentable_area
      }
    }
  }
`

export const GET_PERSON = gql`
  query GetPersonSidePanel($id: Int!) {
    person(id: $id) {
      id
      birthday
      type
      unit_occupancy_tenants {
        id
        pms_id
        is_active
        unit_occupancy {
          id
          pms_id
          status
          property {
            id
            pms_id
            name
          }
          unit_occupancy_tenants {
            id
            pms_id
            is_active
            person {
              id
              first_name
              last_name
            }
          }
        }
      }
      person_guest_cards {
        id
        guest_card {
          id
          property {
            id
            name
          }
        }
      }
      sticky_number {
        id
        phone_number
        property {
          id
          name
        }
      }
    }
  }
`
